var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchAuthSession, getCurrentUser } from '@aws-amplify/auth';
import { THEME_VALUE } from './constants';
import { DEFAULT_FONT_FAMILY, DEFAULT_LANGUAGE } from './helpers';
var fetchSession = function (username, userId, sessionUser) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var _a, _b, _c, _d, _e, _f;
                try {
                    if (userId && sessionUser.tokens) {
                        var defaultUserSetting = {
                            theme: THEME_VALUE.DEFAULT,
                            language: DEFAULT_LANGUAGE,
                            font: DEFAULT_FONT_FAMILY,
                            user_name: username,
                        };
                        var session = {
                            credentials: {
                                accessToken: (_a = sessionUser.tokens) === null || _a === void 0 ? void 0 : _a.accessToken.toString(),
                                idToken: (_d = (_c = (_b = sessionUser.tokens) === null || _b === void 0 ? void 0 : _b.idToken) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '',
                                refreshToken: '',
                            },
                            userInfo: {
                                userName: username,
                                email: (_f = (_e = sessionUser.tokens) === null || _e === void 0 ? void 0 : _e.idToken) === null || _f === void 0 ? void 0 : _f.payload.email,
                                setting: defaultUserSetting,
                            },
                        };
                        resolve(session);
                    }
                }
                catch (error) {
                    reject(new Error('Failure getting Cognito session: ' + error));
                }
            })];
    });
}); };
export var getCognitoSession = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, username, userId, sessionUser, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                return [4 /*yield*/, getCurrentUser()];
            case 1:
                _a = _b.sent(), username = _a.username, userId = _a.userId;
                return [4 /*yield*/, fetchAuthSession()];
            case 2:
                sessionUser = _b.sent();
                return [4 /*yield*/, fetchSession(username, userId, sessionUser)];
            case 3: return [2 /*return*/, _b.sent()];
            case 4:
                error_1 = _b.sent();
                if (error_1.name === 'UserUnAuthenticatedException') {
                    throw error_1;
                }
                throw new Error('Failure getting Cognito session: ' + error_1);
            case 5: return [2 /*return*/];
        }
    });
}); };
